import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';
import { CompanyRanking } from './company-ranking';

export class CompanyFee extends BaseModel {
  static CompanyFeeProperties: (
    | {
        property: keyof CompanyFee;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyFee;
        type: 'alias';
      }
    | {
        property: keyof CompanyFee;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'CompanyId', type: 'column', dataType: 'number' },
    { property: 'CompanyRankingId', type: 'column', dataType: 'number' },
    { property: 'feeType', type: 'column', dataType: 'string' },
    { property: 'feeAmt', type: 'column', dataType: 'number' },
    { property: 'remittanceAmt', type: 'column', dataType: 'number' },
    { property: 'discountAmt', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },

    { property: 'paymentTotal', type: 'alias' },

    { property: 'CompanyRanking', model: 'CompanyRanking', type: 'association' }
  ];

  static {
    CompanyFee.CompanyFeeProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        CompanyFee.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        CompanyFee.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        CompanyFee.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(CompanyFeeObject: Partial<CompanyFee>) {
    super();

    CompanyFee.CompanyFeeProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = CompanyFeeObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  CompanyId?: number;
  CompanyRankingId?: number;
  feeType?: 'BASE' | 'RENEWAL' | 'MULTICLIENT' | 'PREFERRED';
  feeAmt?: number;
  remittanceAmt?: number;
  discountAmt?: number;
  createdAt?: Date;
  updatedAt?: Date;

  // Aliased columns
  paymentTotal?: number;

  CompanyRanking?: CompanyRanking;
}
